/**
 * @author       esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  styles.ts
 */

import { css } from '@emotion/react'
import { Z_INDEX_GROUP_3 } from '@zcode-ui/themes'

export const toggleContainer = css`
  position: fixed;
  bottom: 30px;
  left: 0;
  z-index: ${Z_INDEX_GROUP_3};
  opacity: 1;

  display: flex;
  justify-content: center;
  left: 50%;
  transform: translateX(-50%);
`

export const toggleBtn = css`
  padding: 12px 30px;

  color: #fff;
  font-weight: bold;
  font-size: 15px;

  border: 0;

  filter: drop-shadow(0 8px 8px rgba(0, 0, 0, 0.16));

  background: #e5105a;

  &:hover:not(:disabled) {
    background: #e5105a;
  }
`

export const toggleBtnParent = css`
  z-index: 1000;

  width: 100%;
  margin: 0 auto;
`
